import Dnd from 'bee-dnd'

export default Dnd
